import {addDays, format} from 'date-fns';
import {formatNumber} from 'helpers/common';
import {translate} from 'helpers/localize';
import {TooltipModel} from 'chart.js';
import styles from './PaymentRequestDynamicDiscountChartTooltip.module.scss';
import {memo} from 'react';

interface IProps {
    data: TooltipModel<'line'> | null;
    position: null | {top: number; left: number};
    visibility: boolean;
    amount: number;
    invoiceDate: Date;
}

const PaymentRequestDynamicDiscountChartTooltip = ({
    data,
    position,
    visibility,
    amount,
    invoiceDate,
}: IProps) => {
    const day = data?.dataPoints[0]?.parsed.x || 0;
    const percent = data?.dataPoints[0]?.parsed.y
        ? +parseFloat(data?.dataPoints[0]?.parsed.y.toString()).toFixed(2)
        : 0;
    return (
        <div
            data-notranslate
            className={styles.container}
            style={{
                display: visibility ? undefined : 'none',
                left: position?.left,
                top: position?.top,
            }}
        >
            <div className={styles.tooltipRow}>
                <span>{translate('%{day} day', {day})}</span>
                <span className={styles.value}>
                    {format(addDays(invoiceDate, day), 'MMM dd')}
                </span>
            </div>
            <div className={styles.tooltipRow}>
                <span>{translate('%{percent} %', {percent})}</span>
                {amount > 0 ? (
                    <span className={styles.value}>
                        {formatNumber(amount - amount * (percent / 100))}
                    </span>
                ) : null}
            </div>
        </div>
    );
};

export default memo(PaymentRequestDynamicDiscountChartTooltip);
